import { Button, Divider, Table } from "antd";
import React, { useRef } from 'react';
import Icon, { ICON_NAME } from "../../../../../components/Icon";
import FishHealth from "../../../../../components/Location/FishHealth";
import UnitLice from "../../../../../components/Operation/UnitLice";
import { openPopup2 } from "../../../../../contexts/PopupContext";
import { getSiteDetail, useSiteDetail } from "../../../../../contexts/SiteDetailContext";
import { datetime } from "../../../../../util/library/datetime";
import { selectPermissions } from "../../../../../util/store/selectors";
import { useSelector } from "../../../../../util/store/store";
import { FULL_DATE_FORMAT, weightUnit, zIndex } from "../../../../../util/varibles/constants";
import { formatNumber } from "../../../../../util/varibles/global";
import { IUnit } from "../../../../../util/varibles/interface";
import { ACTION } from "../../../../../util/varibles/permission";
import EditUnit from "./EditUnit";

interface IProps {
}

const Units: React.FC<IProps> = () => {
    const [units, set] = useSiteDetail(state => state.site?.units);
    const get = getSiteDetail();
    const [canUpdateSite] = useSelector(selectPermissions([ACTION.SITE.UPDATE]));

    const columns = useRef([
        {
            title: 'Unit',
            dataIndex: 'unit_id',
            key: 'unitId',
        },
        {
            title: <div>
                <span>Amount</span>
                <Divider orientation='vertical' />
                <span>Avg. weight</span>
            </div>,
            render: (data: IUnit) => {
                return <div>
                    <span>{formatNumber(data.fish_amount)} fish</span>
                    <Divider orientation='vertical' />
                    <span>{formatNumber(data.fish_amount ? data.avg_weight : 0)} gr</span>
                </div>
            },
            key: 'amount',
        },
        {
            title: "Biomass",
            dataIndex: 'total_weight',
            render: (data: number) => {
                return formatNumber(Math.round(data / 1000) / 1000) + ` ${weightUnit.tons.short}`;
            },
            key: 'biomass',
        },
        {
            title: "Lice info",
            render: (data: IUnit) => {
                return <UnitLice lice={data.lice} />;
            },
            key: 'lice',
        },
        {
            title: "Health state",
            render: (data: IUnit) => {
                return <FishHealth value={data.fish_health} />
            },
            key: 'health',
        },
        {
            title: "Health status update date",
            dataIndex: 'fish_health_update_time',
            render: (data: number) => {
                return data ? datetime(data).format(FULL_DATE_FORMAT) : "";
            },
            key: 'health_date',
        },
        {
            title: "Disease",
            dataIndex: 'unit_diseases',
            render: (data: IUnit['unit_diseases']) => {
                const { types = [] } = data || {};
                return types.map(item => item.name).join(',');
            },
            key: 'disease',
        },
        {
            title: "Disease update date",
            dataIndex: 'diseases_update_time',
            render: (data: number) => {
                return data ? datetime(data).format(FULL_DATE_FORMAT) : '';
            },
            key: 'diseases_date',
        },
        {
            title: "",
            width: '40px',
            className: "column-action",
            key: 'action',
            render: (data: IUnit) => {
                return canUpdateSite ? <div>
                    <Button
                        className='bt-ghost'
                        data-icon='true'
                        onClick={() => {
                            const modalProps = { title: "Log fish information " + data.unit_id, zIndex: zIndex.popupLev2 };
                            const { diseases, site, onUpdate } = get();
                            const { id: siteId, units = [] } = site || {};
                            openPopup2(<EditUnit
                                unit={data}
                                siteId={siteId}
                                diseases={diseases?.data || []}
                                units={units}
                                onSave={(value) => {
                                    set(({ site }) => {
                                        if (!site)
                                            return {};

                                        const ids = value.reduce((rs: { [id: string]: Partial<IUnit> }, item) => {
                                            rs[item.id || ''] = item;
                                            return rs
                                        }, {})
                                        const newValue = {
                                            ...site,
                                            units: units.map(item => ({ ...item, ...(ids[item.id] || {}) }))
                                        };
                                        onUpdate?.(newValue);
                                        return { site: newValue }
                                    })
                                }}
                            />, { modalProps });
                        }}
                    >
                        <Icon icon={ICON_NAME.EDIT} />
                    </Button>
                </div> : null
            }
        },
    ]);

    return <div>
        <Table rowKey={"id"} dataSource={units} columns={columns.current} pagination={false} />
    </div>;
};

export default Units;
